<template>
  <v-container fluid>
    <el-overlay-loading :loading="pageloading" />
    <!-- title  -->
    <h1 class="mb-1">{{ $t(getTitle) }}</h1>
    <!-- form  -->
    <v-card outlined class="mb-4">
      <form @keydown.enter.prevent="submit()">
        <v-card-text class="mt-5">
          <v-row class="mb-0 pb-0">
            <v-col class="pb-0" cols="12" md="12">
              <el-text-field
                label="Institucijos grupės pavadinimas (LT)"
                v-model="formData.title_lt"
                :disabled="modeReadonly"
                :maxlength="200"
                required
              />
            </v-col>
            <v-col class="pb-0" cols="12" md="12">
              <el-text-field
                label="Institucijos grupės pavadinimas (EN)"
                v-model="formData.title_en"
                :disabled="modeReadonly"
                :maxlength="200"
                required
              />
            </v-col>
            <v-col class="pb-0" cols="12" md="6" lg="3">
              <el-date-picker
                label="Galioja nuo"
                required
                :disabled="modeReadonly"
                v-model="formData.valid_from"
              />
            </v-col>
            <v-col class="pb-0" cols="12" md="6" lg="3">
              <el-date-picker
                label="Galioja iki"
                :afterDate="formData.valid_from"
                :disabled="modeReadonly"
                v-model="formData.valid_to"
              />
            </v-col>
             <v-col class="pb-0" cols="12" md="6" lg="3">
              <el-text-field
                label="Kodas"
                disabled
                v-model="code"
                :maxlength="20"
              />
            </v-col>
            <v-col cols="12" md="12">
              <el-button
                class="mb-5"
                color="primary"
                icon="pridėti"
                title="Pridėti instituciją"
                :loading="loading"
                @click.native.stop="newInstitution()"
              />
            </v-col>
            <v-col cols="12" md="12">
              <v-data-table
                v-if="showInstitutionsTable"
                class="mb-4 custom-table sticky-header"
                :loading="loading"
                :headers="headers"
                :header-props="{
                  sortByText: $t('Rūšiuoti pagal')
                }"
                :item-class="itemRowBackground"
                :items="institutionsList"
              >
                <template #[`item.actions`]="{ item }">
                  <div class="nowrap">
                    <el-table-action
                      :item="setEdit(item)"
                      @deleteItem="deleteItem({ item, type: 'principals' })"
                    />
                  </div>
                </template>
              </v-data-table>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-row no-gutters>
            <v-spacer></v-spacer>
            <el-button
              class="mr-1"
              color="secondary"
              icon="atšaukti"
              title="Atšaukti"
              @click.native.stop="back()"
              :loading="loading"
            />
            <el-button
              v-if="!modeReadonly"
              title="Išsaugoti"
              :loading="loading"
              @click.native="saveData()"
              color="primary"
              icon="išsaugoti"
            />
          </v-row>
        </v-card-actions>
      </form>
    </v-card>
    <!-- modal  -->
    <modal-add-person
      v-if="showAddInstitution"
      v-model="showAddInstitution"
      :modalType="modalType"
      :additionalData="institutionsList"
      @addPersonData="addInstitution"
    />
    <modal-delete
      title="Įrašo šalinimas"
      :text="`Ar tikrai norite pašalinti?`"
      v-model="showDelete"
      :item="modalDeleteItem"
      @confirmDelete="confirmDelete"
    />
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import userRole from '@/mixins/userRole'
import ModalAddPerson from '@/components/modals/ModalAddPerson'
import ModalDelete from '@/components/modals/ModalDelete'

export default {
  name: 'AdminInstitutionGroupForm',
  components: {
    ModalAddPerson,
    ModalDelete,
  },
  mixins: [userRole],
  $_veeValidate: {
    validator: 'new',
  },
  data() {
    return {
      pageloading: false,
      loading: false,
      formData: {},
      institutionsList: [],
      modalType: null,
      showAddInstitution: null,
      showDelete: false,
      modalDeleteItem: null,
      code: '',
    }
  },
  computed: {
    headers() {
      return [
        {
          text: this.$t('Veiksmai'),
          align: 'center',
          sortable: false,
          value: 'actions',
        },
        {
          text: this.$t('Juridinio asmens kodas'),
          align: 'start',
          value: 'code',
        },
        {
          text: this.$t('Pavadinimas'),
          align: 'start',
          value: 'fullname',
        },
        {
          text: this.$t('Kita informacija'),
          align: 'start',
          value: 'other_info',
        },
      ]
    },
    showInstitutionsTable() {
      return this.institutionsList?.length > 0
    },
    modeReadonly() {
      return false
    },
    getId() {
      return this.$route.params.id || null
    },
    getTitle() {
      if (this.getId) {
        return this.$t(`Redaguoti institucijų grupę`)
      } else {
        return this.$t(`Nauja institucijų grupė`)
      }
    },
  },
  beforeDestroy() {},
  created() {
    if (this.getId) {
      this.getData()
    } 
  },
  methods: {
    itemRowBackground: function (item) {
      return item.type && 'newly-added-row'
    },
    setEdit(item) {
      item.canDelete = true
      return item
    },
    addInstitution(item) {
      this.institutionsList.push(item)
      this.showAddInstitution = false
    },
    newInstitution() {
      this.modalType = 'institution'
      this.showAddInstitution = true
    },
    back() {
      this.$router.push({ name: 'classifierInstitutionsGroups' })
    },
    getData() {
      this.pageloading = true
      this.$axios
        .get(`institution-groups/${this.getId}`)
        .then((res) => {
          this.formData = res.data.institutionGroup
          this.code = this.formData.code
          this.institutionsList = this.formData.institutions
        })
        .catch((err) => {
          this.$root.$emit('DATA_ERROR', err)
        })
        .finally(() => {
          this.pageloading = false
        })
    },
    saveData() {
      this.$validator.validateAll().then((res) => {
        if (res) {
          if(this.institutionsList.length == 0){
            return this.$root.$emit('DATA_ERROR_CODE', '000103')
          }
          this.loading = true
          let formData = this.formData
          formData.code = this.code
          formData.institutions = this.institutionsList.map((item) => {
            return item.amn_id
          })
          let url = `institution-groups`
          this.getId && (formData.id = this.getId)
          this.$axios
            .post(url, formData)
            .then((res) => {
              this.$root.$emit('DATA_OK_CODE', '000110')
              this.back()
            })
            .catch((err) => {
              this.$root.$emit('DATA_ERROR', err)
            })
            .finally(() => {
              this.loading = false
            })
        } else {
          this.$root.$emit('FORMAT_ERROR')
        }
      })
    },
    deleteItem(item) {
      this.modalDeleteItem = Object.assign({}, item)
      this.showDelete = true
    },
    confirmDelete(item) {
      const index = this.institutionsList.findIndex(
        (formItem) => formItem.amn_id === item.item.amn_id
      )
      if (index > -1) {
        this.institutionsList.splice(index, 1)
      }
      this.showDelete = false
    },
  },
}
</script>
<style lang="scss"></style>
